import React from 'react';
import "./PageNotFound.css";
import "../../assets/css/app.css";

function PageNotFound() {
  return (
    <div className="pnf">
        <div className="maxW">
           <div className="pnfMn">
           <h2>404</h2>
            <span>Page Not Found</span>
            <h6>Sorry, we can't find the page you're looking for </h6>
            <a href="/">Back to Home</a>
           </div>
         </div>
       </div>
  )
}

export default PageNotFound